import {environment} from './environments/environment';

export class Configs {
  public static readonly loginPath = '/user/login';
}

